import { createAdminRequest, createRequest } from '../helpers/api_utils';
import { OrganizationLicenses } from '../types/admin_types';
import { apiUrl } from './api_url';

const apiEndpoint = apiUrl + '/admin';

export function getOrganizationSubscriptions(search: string, page: number, page_size: number) {
  const params = new URLSearchParams({
    search,
    page: page.toString(),
    page_size: page_size.toString(),
  });
  const url = `${apiEndpoint}/organization_subscription?${params}`;
  return fetch(createAdminRequest(url, 'GET', 'application/json', true));
}

export function updateLicense(body: OrganizationLicenses) {

  const url = `${apiEndpoint}/license`;
  return fetch(createAdminRequest(url, 'POST', 'application/json', true, body));
}

export function adminLogin(body: {username: string, password: string}) {

  const url = `${apiEndpoint}/login`;
  return fetch(createRequest(url, 'POST', 'application/json', true, body));
}

export function orgUsage(body: {primary_domain: string, month: number, year: number}) {

  const url = `${apiEndpoint}/usage`;
  return fetch(createRequest(url, 'POST', 'application/json', true, body));
}

/** Current month + recent history of one metered feature for a tenant (platform admin). */
export function getFeatureCreditUsage(organizationId: string, feature: string, months = 6) {
  const url = `${apiEndpoint}/organization/${organizationId}/credits/${feature}/usage?months=${months}`;
  return fetch(createAdminRequest(url, 'GET', 'application/json', true));
}
